import { AlertCircle } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useEffect, useState } from "react";
import { t } from "i18next";
import humanizeDuration from "humanize-duration";
import useMapStore from "@/store/mapStore";

function MapFailedAlert() {
  const currentLanguage = useMapStore((state) => state.currentLang);
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let interval: NodeJS.Timeout | null = null;
    if (isActive && seconds > 0) {
      interval = setInterval(() => {
        setSeconds((seconds) => seconds - 1);
      }, 1000);
    } else if (seconds === 0 && isActive) {
      setIsActive(false);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isActive, seconds]);

  useEffect(() => {
    const startTimer = () => {
      setSeconds(120); // Set the timer for 120 seconds
      setIsActive(true);
    };

    startTimer();
  }, []);

  return (
    <Alert variant="destructive" className="border-0 bg-white p-20">
      <AlertCircle className="mt-16 h-12 w-12" />
      <AlertTitle className="text-2xl font-bold">
        {t("temporary-connection-problem")}
      </AlertTitle>
      <AlertDescription>
        {t("trying-to-reconnect-in")}{" "}
        {humanizeDuration(seconds * 1000, {
          delimiter: ` ${t("and")} `,
          round: true,
          language: currentLanguage,
        })}
        .
      </AlertDescription>
    </Alert>
  );
}

export default MapFailedAlert;
